import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutValues from './components/AboutValues';
import AboutProcess from './components/AboutProcess';

const AboutPage = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "Over NGP Renovatieproject",
      "url": `${import.meta.env.VITE_SITE_URL ?? ''}/about`,
      "description": "Leer meer over NGP Renovatieproject – vakmanschap, passie en betrouwbaarheid in elke renovatie in Antwerpen en omgeving.",
      "mainEntity": {
        "@type": "Organization",
        "name": "NGP Renovatieproject",
        "url": `${import.meta.env.VITE_SITE_URL ?? ''}`,
        "description": "Professioneel renovatiebedrijf gespecialiseerd in appartement renovatie, badkamer verbouwing en keuken renovatie in Antwerpen.",
        "email": "ngp.renovatieprojecten@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Adelaarstraat 55 B301",
          "addressLocality": "Merksem",
          "postalCode": "2170",
          "addressCountry": "BE"
        },
        "areaServed": {
          "@type": "City",
          "name": "Antwerpen"
        }
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-about';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('schema-about');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <AboutStory />
      <AboutValues />
      <AboutProcess />
      <Footer />
    </div>
  );
};

export default AboutPage;
